import { API } from '@/utils/API';

declare global {
  interface Window {
    Beacon?: (method: string, options?: unknown, data?: unknown) => void;
  }
}

export const logoutNavigation = {
  redirectToRoot: () => window.location.assign('/'),
};

export const logout = () => {
  if (window.Beacon) {
    try {
      window.Beacon('logout');
    } catch (error) {
      console.warn('Failed to logout from Beacon:', error);
    }
  }

  return API.authenticated
    .fetch('/auth/logout', {
      method: 'DELETE',
    })
    .finally(() => {
      logoutNavigation.redirectToRoot();
    });
};
